import { getCookie } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';
import * as Countries from '@porterin/component-library/config/countries';
import * as Languages from '@porterin/component-library/config/languages';

export function getCountryDataFromCode(country_code: string) {
  if (!country_code) return null;
  const key = country_code.toLowerCase() as keyof typeof Countries;
  return key in Countries ? Countries[key] : null;
}

export function getLanguageDataFromCode(language_code: string) {
  if (!language_code) return null;
  const key = language_code.toLowerCase() as keyof typeof Languages;
  return key in Languages ? Languages[key] : null;
}

export function getLocaleHeaders() {
  const localeCookie = getCookie('NEXT_LOCALE');

  const countryCode = localeCookie?.split('-')[1]?.toLowerCase() ?? 'bd'; // as 'en' is the locale for bangladesh english
  const languageCode = localeCookie?.split('-')[0]?.toLowerCase() ?? 'en';

  return {
    'preferred-language':
      getLanguageDataFromCode(languageCode)?.languageHeaderCode ?? 'en',
    'country': getCountryDataFromCode(countryCode)?.countryHeaderCode ?? 'bd',
  };
}

export function getLocaleDataFromCookie() {
  const localeCookie = getCookie('NEXT_LOCALE');

  const countryCode = localeCookie?.split('-')[1]?.toLowerCase() ?? 'bd';
  const languageCode = localeCookie?.split('-')[0]?.toLowerCase() ?? 'en';

  const countryData = getCountryDataFromCode(countryCode);
  const languageData = countryData?.languages[languageCode];
  if (!countryData || !languageData) throw Error('Invalid locale');

  return {
    country: countryData,
    language: languageData,
  };
}
